import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import {PAGE_TAB_NAME_NEW} from '../../constant';
import PageTitleAsBreadCrumbs from '../../shared/PageTitleAsBreadCrumbs';
import LastUpdateTime from '../../shared/LastUpdateTime';
import SaveNewPreferenceButton from './SaveNewPreferenceButton';
import { initializePreferenceSaveService, preferenceSaveService } from '../../services/preferenceSaveService';
import PreferenceStructureIncluded from './PreferenceStructureIncluded';
import PreferenceStructureType from './PreferenceStructureType';
import PreferenceStructureItemCode from './PreferenceStructureItemCode';
import PreferenceStructureWhen from './PreferenceStructureWhen';
import PreferenceStructureItemHowOften from './PreferenceStructureItemHowOften';
import PreferenceStructureGroup from './PreferenceStructureGroup';
import PreferenceStructurePhrase from './PreferenceStructurePhrase';
import { createPreferenceSelectGroupService } from '../../services/preferenceGroupSelectService';
import { preferencesGroupsStorage } from '../../services/preferencesGroupsStorage';
import { productsStorage } from '../../services/productsStorage';
import { propertiesStorage } from '../../services/propertiesStorage';
import {RepeatIcon} from "../../appearence/icons/repeat_icon";
import {PreferenceType} from "../../services/preferenceTypes";
import {IconWrapper} from "../../appearence/icons/icon_wrapper";
import {lastUpdateTimeService} from "../../services/lastUpdateTimeService";

const getCombinedPreferenceKey = (id, index) => {
    if (id) {
        return id + index;
    }
    return index;
};

const PreferenceItemEdit = () => {
    const { id } = useParams();
    const [preferenceIsReady, setPreferenceIsReady] = useState(null);

    const changePreferenceReadyState = () => {
        setPreferenceIsReady(uuid());
    };

    const getFormKey = () => {
        return (PAGE_TAB_NAME_NEW || id) + preferenceIsReady;
    };

    const handleRegeneratePhrases = () => {
        preferenceSaveService.regeneratePhrases();
    };

    useEffect(() => {
        preferenceSaveService.cleanService();
        if(id !== PAGE_TAB_NAME_NEW) {
            initializePreferenceSaveService(id);
        } 
        propertiesStorage.loadItems(() => {});
        productsStorage.loadItems(() => {});
        preferencesGroupsStorage.loadItems();
        lastUpdateTimeService.cleanObservers();
        preferenceSaveService.registerItemUpdateObserver(changePreferenceReadyState);
        return () => {
            preferenceSaveService.unRegisterItemUpdateObserver(changePreferenceReadyState);
            preferenceSaveService.cleanService();
            lastUpdateTimeService.cleanObservers();
        };
    }, [id]);

    return (
        <>
            <PageTitleAsBreadCrumbs />
            <article className="preference__article preference__article_full-width preference__article-add">
                <form className="preference__form" key={getFormKey()}>
                    {id === PAGE_TAB_NAME_NEW ?
                        <SaveNewPreferenceButton />
                        :
                        <LastUpdateTime itemSaveService={preferenceSaveService} />}
                    <div key={"1"} className="preference__form-column">
                        <PreferenceStructureIncluded itemSaveService={preferenceSaveService} />
                        <PreferenceStructureType parentMode={true}/>
                        {preferenceSaveService.getPreference().preferenceType === PreferenceType.COMBINATION ?
                            <div className="preference__form-combination">
                                {preferenceSaveService.getPreference().combinedPreferences.map((it, index) => (
                                    <React.Fragment key={getCombinedPreferenceKey(it.id, index)}>
                                        <PreferenceStructureType key={"PreferenceStructureType" + getCombinedPreferenceKey(it.id, index)} index={index} parentMode={false}/>
                                        <PreferenceStructureItemCode
                                            key={"PreferenceStructureItemCode" + getCombinedPreferenceKey(it.id, index)}
                                            preferenceStructureItem={preferenceSaveService.getCombinedPreferenceItem(index)}
                                            index={index}
                                            parentMode={false}/>
                                    </React.Fragment>
                                ))}
                                <PreferenceStructureType parentMode={false}/>
                                <PreferenceStructureItemCode
                                    preferenceStructureItem={preferenceSaveService.getCombinedPreferenceItem(null)}
                                    parentMode={false}/>
                            </div>
                            :
                            <PreferenceStructureItemCode
                                preferenceStructureItem={preferenceSaveService.getPreferenceItem()}
                                parentMode={true} />
                        }
                        <PreferenceStructureWhen itemSaveService={preferenceSaveService} />
                    </div>
                    <div key={"2"} className="preference__form-column">
                        <PreferenceStructureItemHowOften itemSaveService={preferenceSaveService} />
                        <PreferenceStructureGroup selectWithTokensManager={createPreferenceSelectGroupService()} />
                        <PreferenceStructurePhrase preferenceId={id} />
                        <label className="block__text preference__form-label">
                            <IconWrapper><RepeatIcon handleClick={handleRegeneratePhrases}/></IconWrapper>
                        </label>
                    </div>
                </form>
            </article>
        </>
    );
};

export default PreferenceItemEdit;
